import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter, input } from '@angular/core';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Player } from '../../../models/Player';
import { ApplicationService } from '../../../services/application.service';
import { PlayerService } from '../../../services/player.service';
import { CreatePlayerRequest } from '../../../models/createPlayerRequest';
import { setThrowInvalidWriteToSignalError } from '@angular/core/primitives/signals';

@Component({
  selector: 'app-add-edit-player',
  standalone: true,
  imports: [FormsModule, NgIf],
  templateUrl: './add-edit-player.component.html',
  styleUrl: './add-edit-player.component.css'
})
export class AddEditPlayerComponent implements OnChanges {

  constructor(private applicationService:ApplicationService, private playerService:PlayerService) {}

  @Input() playerToUpdate:Player|null = null;
  @Input() isNewPlayerRequest:boolean = false;
  @Input() title:string = "Update Your Profile";
  @Input() saveButtonText:string = "Save Profile";
  @Output() saved = new EventEmitter<number>;
  @Output() canceled = new EventEmitter<void>;

  playerId:number|null = null;
  firstName:string = '';
  lastName:string = '';
  email:string|null = null;
  phone:string|null = null;
  handicapIndex:number|null = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['playerToUpdate'] && this.playerToUpdate) {
      this.isNewPlayerRequest = false;
      this.playerId = this.playerToUpdate.id;
      this.firstName = this.playerToUpdate.firstName;
      this.lastName = this.playerToUpdate.lastName;
      this.email = this.playerToUpdate.email;
      this.phone = this.playerToUpdate.phone;
      this.handicapIndex = this.playerToUpdate.handicapIndex;
    }
  }

  async save() {
    this.applicationService.showGlobalSpinner();

    let result = 0;
    if(this.playerId && this.playerToUpdate) {
      this.playerToUpdate.firstName = this.firstName;
      this.playerToUpdate.lastName = this.lastName;
      this.playerToUpdate.email = this.email;
      this.playerToUpdate.phone = this.phone;
      this.playerToUpdate.handicapIndex = this.handicapIndex;

      await this.playerService.updatePlayer(this.playerToUpdate);
      result = this.playerId;
    }
    else {
      let request:CreatePlayerRequest = {
        email: this.email,
        firstName: this.firstName,
        handicapIndex: this.handicapIndex,
        lastName: this.lastName,
        phone: this.phone
      };

      result = await this.playerService.createPlayer(request);
    }

    this.applicationService.hideGlobalSpinner();
    this.saved.emit(result);
  }
  
  cancel():void {
    this.canceled.emit();
  }

  onPhoneInput() {
    const value = this.phone ?? '';
    this.phone =
      value.replace(/[^0-9]/g, '').slice(0, 10);
  }


}
